

































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import AbpBase from "../../../lib/abpbase";
import appconst from "../../../lib/appconst";

interface MetricPoint {
  t: number;
  v: number | null;
}

interface MetricSeries {
  name: string;
  color: string;
  points: MetricPoint[];
}

interface MetricChart {
  key: string;
  title: string;
  unit: string;
  decimals: number;
  description: string;
  error: string | null;
  series: MetricSeries[];
}

interface ApiOverview {
  fromUtc: string;
  toUtc: string;
  stepSeconds: number;
  channel: string;
  charts: MetricChart[];
}

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class ApiMonitoring extends AbpBase {
  loading = false;
  loadError = "";
  charts: MetricChart[] = [];
  channel = "";
  lastRefreshed = "";

  hoursBack = 24;
  autoRefresh = false;
  private timer: number | null = null;

  rangeOptions = [
    { text: "Son 6 saat", value: 6 },
    { text: "Son 24 saat", value: 24 },
    { text: "Son 48 saat", value: 48 },
    { text: "Son 7 gun", value: 168 },
  ];

  breadcrumbsItems = [
    { text: "Ana Sayfa", disabled: false, href: "/main/home" },
    { text: "API Izleme", disabled: true },
  ];

  async loadOverview() {
    this.loading = true;
    this.loadError = "";

    try {
      // Panelin kendi API'si degil metrik sunucusu cagrilir: VictoriaMetrics
      // yalnizca o makinede erisilebilir durumda.
      const response = await axios.get<{ result: ApiOverview }>(
        appconst.metricsBaseUrl + "/api/services/app/Monitoring/GetApiOverview",
        {
          params: { hoursBack: this.hoursBack },
          headers: {
            Authorization: "Bearer " + (window as any).abp.auth.getToken(),
          },
          timeout: 60000,
        }
      );

      const sonuc = response.data.result;
      this.charts = sonuc.charts;
      this.channel = sonuc.channel;
      this.lastRefreshed = new Date().toLocaleTimeString("tr-TR");
    } catch (error) {
      const hata = error as any;
      this.loadError =
        (hata && hata.response && hata.response.status === 401
          ? "Yetki reddedildi (401)"
          : hata && hata.message) || "bilinmeyen hata";
    } finally {
      this.loading = false;
    }
  }

  // "reservations" bilincli olarak cizilmiyor: uc noktanin siparis sayimi
  // ABP'nin kiracı filtresi yuzunden host oturumda sifir donuyor. Duzeltme
  // API kaynagina girdi, canliya cikinca bu listeye "reservations" eklenerek
  // grafik geri acilir.
  private static readonly CIZILEN = ["requests", "unserved"];

  get gosterilecekGrafikler(): MetricChart[] {
    return this.charts.filter(
      (c) => ApiMonitoring.CIZILEN.indexOf(c.key) !== -1
    );
  }

  chartSeries(chart: MetricChart) {
    // Seriler farkli uzunlukta gelebiliyor: bir sayac yalnizca olay olunca
    // olustugu icin gec baslayabilir. En uzun serinin zaman eksenine
    // oturtulmazsa kisa seri grafigin tum zaman araligini kendine gore
    // daraltiyor. Eksikler sifir, acikca null gelenler null kalir; boylece
    // "olay olmadi" ile "veri gelmedi" ayri gorunur.
    let eksen: number[] = [];
    chart.series.forEach((s) => {
      if (s.points.length > eksen.length) {
        eksen = s.points.map((p) => p.t);
      }
    });

    return chart.series.map((s) => {
      const harita = new Map<number, number | null>();
      s.points.forEach((p) => harita.set(p.t, p.v));

      return {
        name: s.name,
        data: eksen.map((t) => [t, harita.has(t) ? harita.get(t) : 0]),
      };
    });
  }

  chartOptions(chart: MetricChart) {
    const decimals = chart.decimals;
    const unit = chart.unit;

    return {
      chart: {
        id: chart.key,
        type: "area",
        toolbar: { show: true, tools: { download: false } },
        zoom: { enabled: true, type: "x" },
        animations: { enabled: false },
        fontFamily: "inherit",
      },
      colors: chart.series.map((s) => s.color),
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 2 },
      fill: {
        type: "gradient",
        gradient: { opacityFrom: 0.35, opacityTo: 0.02 },
      },
      legend: { show: chart.series.length > 1, position: "bottom" },
      grid: { borderColor: "rgba(0,0,0,0.08)" },
      xaxis: {
        type: "datetime",
        labels: { datetimeUTC: false },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          formatter: (val: number) =>
            val === null || val === undefined ? "" : val.toFixed(decimals),
        },
      },
      tooltip: {
        shared: true,
        x: { format: "dd MMM HH:mm" },
        y: {
          formatter: (val: number) =>
            val === null || val === undefined
              ? "veri yok"
              : val.toFixed(decimals) + " " + unit,
        },
      },
      noData: { text: "Veri yok" },
    };
  }

  onAutoRefreshChange() {
    this.stopTimer();

    if (this.autoRefresh) {
      // Metrikler dakikada bir uretiliyor, daha sik yenilemek bosa yuk.
      this.timer = window.setInterval(() => this.loadOverview(), 60000);
    }
  }

  private stopTimer() {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  mounted() {
    this.loadOverview();
  }

  beforeDestroy() {
    this.stopTimer();
  }
}
